import styled from '@emotion/styled';
import { shadowLight } from 'app/colors';
import Button from 'components/Button';
import { SettingsContentCard } from 'components/Card/Card';
import { CUSTOM_NAVIGATION_Z_INDEX } from 'components/CustomNavigation/constants';

export const StyledSettingsContentCard = styled(SettingsContentCard)`
  height: calc(
    100vh - ${({ navBarHeight }) => navBarHeight + 1}px - 112px - 20px
  );
  min-height: 500px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
`;

export const NavBarPreviewArea = styled.div`
  border: 1px solid var(--color-border-medium-light);
  ${shadowLight}
  margin-top: 20px;
  padding-left: 20px;
  position: relative;
  z-index: ${CUSTOM_NAVIGATION_Z_INDEX};
`;

export const Header = styled.div`
  display: flex;
  margin-bottom: 13px;
`;

export const StyledButtonWrapper = styled.div`
  margin-left: auto;
  margin-top: -5px;
  display: flex;
  column-gap: 10px;
`;

export const StyledButton = styled(Button)`
  margin: 0;
`;
